module.exports = __webpack_public_path__ + "robots.txt";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=robots.txt!./app/static/robots.txt
 ** module id = 931
 ** module chunks = 0
 **/